export default class ClaimDailyLoginCommand {
	static protocol = {}

	constructor() {}
}
